import React from 'react';
import PropTypes from 'prop-types';
import { NavItem } from 'react-bootstrap';
import LinkContainer from 'react-router-bootstrap/lib/LinkContainer';


export class SecureMessageNavLink extends React.Component {
  render() {
    return <LinkContainer
      className="visible-md-inline visible-lg-inline no-background-color"
      to="/secure-messages"
      data-qa-item="secureMsgIcon"
    >
          <NavItem>
              <span
                className="fa fa-envelope-o"
                aria-hidden="true"
              />
              {
                this.props.tab.badgeProperties.stateCounter > 0 ?
                <span data-qa-item="secureMsgCount"
                  className="badge messages"
                >{this.props.tab.badgeProperties.stateCounter}
                </span> :
                <span className="hidden">-</span>
              }
          </NavItem>
           </LinkContainer>;
  }
}

SecureMessageNavLink.propTypes = {
  tab: PropTypes.object,
};
